// extracted by mini-css-extract-plugin
module.exports = {"spinnerHolder":"Layout_spinnerHolder__1iK5x"};